import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const api = import.meta.env.VITE_API_URL;

function Profile() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const id = localStorage.getItem("player");
    if (!id) {
      navigate("/");
    }

    const fetchData = async () => {
      try {
        const response = await fetch(`${api}/api/players/${id}`);
        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <p className="text-white text-2xl">Loading...</p>
      </div>
    );
  }

  if (!userData) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <p className="text-white text-2xl">No user data available</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white p-4">
      {/* Page Title */}
      <h1 className="text-3xl sm:text-5xl font-bold mb-8 text-center">
        Player Profile
      </h1>

      {/* Profile Card */}
      <div className="max-w-lg mx-auto bg-white/10 backdrop-blur-md p-4 rounded-2xl shadow-xl">
        {/* Profile Image */}
        <div className="flex justify-center mb-6">
          <img
            src={userData.photo || "https://via.placeholder.com/150"}
            alt="Profile"
            className="w-32 h-32 rounded-full object-cover border-4 border-white shadow-lg"
          />
        </div>

        {/* Player Name */}
        <h2 className="text-2xl font-semibold text-center mb-2">
          {userData?.name
            ?.split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ")}{" "}
          {userData?.islocal === 1 ? "" : "✈️"}
        </h2>
        <p className="text-center text-gray-300 text-sm mb-6">
          {userData?.email || "No Email Available"}
        </p>

        {/* Info Grid */}
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
          <div className="bg-gradient-to-r from-purple-600 to-pink-500 p-4 rounded-lg shadow-md text-center">
            <p className="font-semibold">Phone</p>
            <p className="text-gray-100">{userData.phone || "N/A"}</p>
          </div>

          <div className="bg-gradient-to-r from-blue-600 to-indigo-500 p-4 rounded-lg shadow-md text-center">
            <p className="font-semibold">Address</p>
            <p className="text-gray-100">
              {userData?.address
                ?.split(" ")
                .map(
                  (word) =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join(" ") || "N/A"}
            </p>
          </div>

          <div className="bg-gradient-to-r from-green-600 to-emerald-500 p-4 rounded-lg shadow-md text-center">
            <p className="font-semibold">Batting Style</p>
            <p className="text-gray-100">
              {userData?.style === 1
                ? "Right-Handed"
                : userData?.style === 2
                ? "Left-Handed"
                : "Unknown"}
            </p>
          </div>

          <div className="bg-gradient-to-r from-orange-500 to-red-500 p-4 rounded-lg shadow-md text-center">
            <p className="font-semibold">Role</p>
            <p className="text-gray-100">
              {(() => {
                switch (userData?.role) {
                  case 1:
                    return "Batsman";
                  case 2:
                    return "Wicket-Keeper";
                  case 3:
                    return "Batsman-Allrounder";
                  case 4:
                    return "Bowler-Allrounder";
                  case 5:
                    return "Bowler";
                  default:
                    return "Unknown";
                }
              })()}
            </p>
          </div>

          <div className="bg-gradient-to-r from-teal-500 to-cyan-500 p-4 rounded-lg shadow-md text-center sm:col-span-2">
            <p className="font-semibold">Status</p>
            <p className="text-gray-100">
              {userData.status === 1 ? "Active ✅" : "Inactive ❌"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
